import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { Btn } from '@/components/ui/Btn'
import { Field } from '@/components/ui/Field'

export default function RecuperarSenhaPage() {
  const { resetPassword } = useAuth()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [err, setErr] = useState('')

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setErr('')
    try {
      await resetPassword(email.trim())
      setSent(true)
    } catch (e: unknown) {
      const code = (e as { code?: string }).code
      // Não revelamos se o e-mail existe ou não (anti-enumeração): "não encontrado"
      // mostra a mesma tela de sucesso. Só e-mail malformado vira erro visível.
      if (code === 'auth/user-not-found') {
        setSent(true)
      } else if (code === 'auth/invalid-email') {
        setErr('E-mail inválido. Confira o endereço digitado.')
      } else {
        setErr('Não foi possível enviar agora. Tente novamente em instantes.')
      }
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-5">
      <form onSubmit={submit} className="w-full max-w-md bg-card border border-border rounded-3xl p-9">
        <h1 className="text-2xl font-extrabold mb-2">Criar ou recuperar senha</h1>
        <p className="text-text-secondary text-sm mb-5">
          Primeiro acesso ou esqueceu a senha? Digite o e-mail cadastrado no sistema —
          se ele estiver no nosso banco, enviamos um link pra você definir sua senha.
        </p>
        {sent ? (
          <div className="bg-success/10 border border-success/40 rounded-lg p-4 text-success text-sm">
            ✅ Se esse e-mail estiver cadastrado, enviamos um link pra criar sua senha.
            Confira sua caixa de entrada (e a pasta de spam).
            <div className="mt-3"><Link to="/login" className="underline">Voltar pro login</Link></div>
          </div>
        ) : (
          <>
            <Field label="Email" value={email} onChange={setEmail} type="email" required />
            {err && <div className="text-danger text-xs mt-2">{err}</div>}
            <Btn type="submit" className="w-full mt-5">Enviar link</Btn>
            <div className="text-center mt-4">
              <Link to="/login" className="text-xs text-text-secondary hover:text-accent">Voltar pro login</Link>
            </div>
          </>
        )}
      </form>
    </div>
  )
}
